import { appServiceApi } from "../../../app/appServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../types";
import {
  GetPortalSingleSubDepartmentByIdDataType,
  GetProtalAllDepartmentDataType,
  GetProtalAllDepartmentParamsType,
  GetProtalAllSubDepartmentDataType,
  GetProtalAllSubDepartmentParamsType,
  GetProtalSingleDepartmentDataType,
  GetProtalSingleSubDepartmentDataType,
} from "../../../types/portal/settings";

export const settingsApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    createPortalDepartment: builder.mutation({
      query: (data) => ({
        url: API_URL.createPortalDepartment,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllProtalDepartment"];
        return [];
      },
    }),

    updatePortalDepartment: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updatePortalDepartment}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAllProtalDepartment",
            {
              type: "GetSingleProtalDepartment",
              id,
            },
          ];

        return [];
      },
    }),

    updatePortalStatusDepartment: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updatePortalStatusDepartment}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAllProtalDepartment",
            {
              type: "GetSingleProtalDepartment",
              id,
            },
          ];

        return [];
      },
    }),

    deletePortalDepartment: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_URL.deletePortalDepartment}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllProtalDepartment"];
        return [];
      },
    }),

    getProtalAllDepartment: builder.query<
      GetProtalAllDepartmentDataType,
      GetQueryArgsType<GetProtalAllDepartmentParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getProtalAllDepartment,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllProtalDepartment"],
    }),

    getProtalSingleDepartment: builder.query<
      GetProtalSingleDepartmentDataType,
      number
    >({
      query: (id) => ({
        url: `${API_URL.getProtalSingleDepartment}/${id}`,
      }),
      providesTags: ["GetSingleProtalDepartment"],
    }),

    createPortalSubDepartment: builder.mutation({
      query: (data) => ({
        url: API_URL.createPortalSubDepartment,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllProtalSubDepartment"];
        return [];
      },
    }),

    updatePortalSubDepartment: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updatePortalSubDepartment}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAllProtalSubDepartment",
            {
              type: "GetSingleProtalSubDepartment",
              id,
            },
          ];

        return [];
      },
    }),

    updatePortalStatusSubDepartment: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updatePortalStatusSubDepartment}/${id}/status`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAllProtalSubDepartment",
            {
              type: "GetSingleProtalSubDepartment",
              id,
            },
          ];

        return [];
      },
    }),

    deletePortalSubDepartment: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_URL.deletePortalSubDepartment}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllProtalSubDepartment"];
        return [];
      },
    }),

    getProtalAllSubDepartment: builder.query<
      GetProtalAllSubDepartmentDataType,
      GetQueryArgsType<GetProtalAllSubDepartmentParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getProtalAllSubDepartment,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllProtalSubDepartment"],
    }),

    getProtalSingleSubDepartment: builder.query<
      GetProtalSingleSubDepartmentDataType,
      number
    >({
      query: (id) => ({
        url: `${API_URL.getProtalSingleSubDepartment}/${id}`,
      }),
      providesTags: ["GetSingleProtalSubDepartment"],
    }),

    getPortalSingleSubDepartmentById: builder.query<
      GetPortalSingleSubDepartmentByIdDataType,
      any
    >({
      query: ({ params }) => ({
        url: `${API_URL.getPortalSingleSubDepartmentById}/${params?.department_id}`,
        params: {
          skip: params?.skip,
          page: params?.page,
          limit: params?.limit,
          status: params?.status,
        },
      }),
      providesTags: ["GetPortalSingleSubDepartmentById"],
    }),
  }),
});

export const {
  useCreatePortalDepartmentMutation,
  useUpdatePortalDepartmentMutation,
  useUpdatePortalStatusDepartmentMutation,
  useDeletePortalDepartmentMutation,
  useGetProtalAllDepartmentQuery,
  useGetProtalSingleDepartmentQuery,
  useCreatePortalSubDepartmentMutation,
  useUpdatePortalSubDepartmentMutation,
  useUpdatePortalStatusSubDepartmentMutation,
  useDeletePortalSubDepartmentMutation,
  useGetProtalAllSubDepartmentQuery,
  useGetProtalSingleSubDepartmentQuery,
  useGetPortalSingleSubDepartmentByIdQuery,
} = settingsApi;
